import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { NguCarousel, NguCarouselConfig } from '@ngu/carousel';
import { Subscription } from 'rxjs';
import { distinct } from 'rxjs/operators';
import { AppConfig } from 'src/app/config-service/app.config';
import { BehaviorSubjectService } from 'src/app/utility-packages/is-logged-in/behaviorSubject.service';
import { cardDetailResModel } from '../../models/cardBalanceResponse.model';
import { favoriteServiceResModel, userFavoritesResModel, virtualCardsResModel } from '../../models/favoriteResponse.model';
import { removeItemsFromUI } from '../../ngrx/home-actions';
import { FavoriteService } from '../../services/favorite.service';
import { FavoritesBaseClass } from '../favorites-base-class/favorites-base';
import { insertionSort } from './sort/function/insertion-sort';
import { ModalActionsFactory } from './utility-classes/modal-actions';
import { SliderService } from './utility-classes/slider/slider.service';

@Component({
  selector: 'favorite-cards',
  templateUrl: './favorite-cards.component.html',
  styleUrls: ['../../home/home.component.scss', './favorite-cards.component.css']
})
export class FavoriteCardsComponent extends FavoritesBaseClass implements OnInit {
  @ViewChild('carousel') carousel!: NguCarousel<any>;
  
  favoriteResult!: favoriteServiceResModel;
  userFavoriteResult: Array<userFavoritesResModel> = [];
  virtualCardsResult: Array<virtualCardsResModel> = [];
  cardDetailResult: Array<cardDetailResModel> = [];
  tempCardDetailResult: Array<cardDetailResModel> = [];

  subscriptions:Subscription = new Subscription();

  apiSettings = AppConfig.settings;

  isLogin = false;
  isRouting = false;
  isLoading = false;

  isFavoritesLoaded = false;
  isCardsLoaded = false;

  public carouselTileItems: Array<any> = [];
  public carouselTile: NguCarouselConfig = {
    grid: { xs: 1, sm: 1, md: 2, lg: 2, all: 0 },
    slide: 3,
    speed: 250,
    point: {
      visible: true,
    },
    load: 2,
    velocity: 0,
    touch: true,
    easing: 'cubic-bezier(0, 0, 0.2, 1)',
  };

  constructor(
    public behaviorSubjectService: BehaviorSubjectService,
    private _cdr: ChangeDetectorRef,
    public restFavorite: FavoriteService,
    protected store: Store,
    private modalService: NgbModal,
    private slider: SliderService
  ) {
    super(store);
  }

  ngOnInit(): void {
    this.requestCardsAndFavoritesIfNotExist();

    this.subscriptions.add(
      this.loadCardsAndFavorites().subscribe(([favorites, cards]) => {
        this.userFavoriteResult = insertionSort<Pick<userFavoritesResModel, 'typeDescription'>, userFavoritesResModel>(favorites);
        this.virtualCardsResult = cards;
        const allFavorites = [...this.userFavoriteResult, ...this.virtualCardsResult];
        
        this.carouselTileItems = allFavorites;
      })
    );

    this.subscriptions.add(
      this.behaviorSubjectService.isUserLoginBS.subscribe(status => {
        if (!status){
          this.store.dispatch(removeItemsFromUI());
          this.carouselTileItems = [];
        }

        this._cdr.detectChanges();
      })
    );

  }

  ngAfterViewInit(){
    this.emitActiveIndexes();
    this.subscriptions.add(
      this.carousel.onMove.subscribe(active => {
        this.emitActiveIndexes();
      })
    )
  }

  emitActiveIndexes = () => {
    for(let i = this.carousel.currentSlide; i < this.carousel.currentSlide + this.carousel.slideItems; i++){
      this.slider.emitActiveCards(i)
    }
  }

  ngOnDestroy(){
    this.unsubscribeFromFavoriteOps();
    this.subscriptions.unsubscribe();
  }

  onBalanceQueryModal() {
    const modalAction = new ModalActionsFactory(this.modalService).getModalAction('AddtoFav')
    modalAction.openModal();
  }

  onOnlineChargeModal() {
    const modalAction = new ModalActionsFactory(this.modalService).getModalAction('OnlineCharge')
    modalAction.openModal();
  }
}